import { useMyBtFollowedKeywordsInfo } from "@features/mybt/hooks/useMyBtFollowedKeywordsInfo";

/**
 * This component is used to fetch the followed keywords by the user and set them in the store.
 */
const MyBTFollowedKeywords = (): React.ReactElement => {
  useMyBtFollowedKeywordsInfo();

  return <></>;
};

export default MyBTFollowedKeywords;
